<template>
  <div class="row">
    <div class="col-sm"></div>
    <div class="col-sm-8 text-center">
      <div class="white_block">
        <div class="mx-auto" data-toggle="timeButtons">
          <!-- <p-button v-translate class="my-0 time-btn" @click="selectDate(1)">Day</p-button> -->
          <p-button v-translate class="time-btn" @click="selectDate(7)"
            >Week</p-button
          >
          <p-button v-translate class="time-btn" @click="selectDate(30)"
            >Month</p-button
          >
          <date-picker
            @change="selectCustomDate(value[0], value[1])"
            v-model="value"
            type="daterange"
            start-placeholder="Начальная дата"
            end-placeholder="Конечная дата"
            style="width: 100%; max-width: 290px"
            value-format
          ></date-picker>
        </div>
      </div>
    </div>
    <div class="col"></div>
  </div>
</template>


<script>
import DatePicker from "element-ui/lib/date-picker";
import PButton from "../../UIComponents/Button";

export default {
  name: "PeriodSelector",

  components: { DatePicker, PButton },

  data() {
    return {
      value: "",
    };
  },
  // props: {
  //   selectDate: Function,
  //   selectCustomDate: Function,
  // },
  methods: {
    selectDate(days) {
      this.$emit("select-date", days);
    },
    selectCustomDate(from, to) {
      this.$emit("select-custom-date", { from, to });
    },
  },
};
</script>

<style scoped lang="sass">
.time-btn
  background-color: white
  border-radius: 4px
  color: #6c757d
  margin: 0 10px
  &:focus,
  &:hover
    background-color: #6c68cb !important
    color: white !important

  .white_block
    background: white
    margin: 5px
    padding: 10px 20px
    border-radius: 4px
    box-shadow: 0 8px 20px rgba(0,0,0,0.1)
    margin-bottom: 7px

@media (prefers-color-scheme: dark)
  .time-btn
    color: #fff
    background-color: black
    &:focus,
    &:hover
      color: white !important
</style>
